import Vue from 'vue';
import {
    CarouselItem,
    Carousel
} from 'element-ui';

Vue.use(Carousel);
Vue.use(CarouselItem);

export default {
    name: 'menuAd',
    data() {
        return {
            list:[]
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        async getData() {
            const res = await Vue.$ajax.get('menuAdvertising', {});
            if (!res.errorType) {
                if (res.menu || res.menu.length > 0) {
                    this.list = res.menu.slice(0, 5); // 限制最大5
                }
            } else {
                console.log(res.errmsg);
            }
        },
    }
};



// WEBPACK FOOTER //
// ./src/components/MenuAd/menuAd.js